<template>
    <div class="wrapper">
     <!--   <div style="height: 7%;">
            <div style="float: right">
               &lt;!&ndash; <el-button  type="primary"  class="foot-save-btn">预 览</el-button>&ndash;&gt;
               &lt;!&ndash; <el-button   v-print="printObjT" type="primary"  class="foot-save-btn">保存模板数据</el-button>&ndash;&gt;
            </div>
        </div>-->
    <!--  <div style="height: 93%">-->
        <div style="height: 100%">
            <el-tabs style="height: 100%" type="card">
              <!--  <el-tab-pane>
                    <span slot="label"><i class="el-icon-date"></i> 我的行程</span>
                    我的行程
                </el-tab-pane>-->
                <el-tab-pane  label="表单编辑器" >
                    <div class="myformMaking">
                    <fm-making-form
                            style="height: 750px"
                        ref="makingform"
                        generate-json
                >
                    <template slot="action">
                        <!-- 自定义操作区域插槽 -->
                        <el-button @click="showTempleteValue" type="text" icon="el-icon-upload">保存</el-button>
                    </template>
                </fm-making-form></div>
                </el-tab-pane>
                <el-tab-pane :lazy="true" label="表单编辑器">高级编辑器</el-tab-pane>
            </el-tabs>

      </div>
        <el-dialog title="新增模板" :visible.sync="dialogVisible">
            <el-form :model="templateForm" :rules="templateRules" ref="templateForm" label-width="100px" class="demo-ruleForm">
                <el-form-item label="模板名称" prop="templ_name">
                    <el-input
                            placeholder="模板名称"
                            v-model="templateForm.templ_name">
                    </el-input>
                </el-form-item>

                <el-form-item label="备注" prop="remarks">
                    <el-input
                            type="textarea"
                            :autosize="{ minRows: 5, maxRows: 10}"
                            placeholder="备注"
                            v-model="templateForm.remarks">
                    </el-input>
                </el-form-item>

            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button    @click="saveTempleteValue" type="primary"  class="foot-save-btn">保存</el-button>
               <!-- <el-button  @click="saveTempleteValue" type="primary"  class="foot-save-btn">保存</el-button>-->
            </div>
        </el-dialog>
      <!--  <div id="printMe"> <fm-generate-form
                :data="jsonData"
                :remote="remoteFuncs"
                :value="values"
                ref="generateForm">
        </fm-generate-form> </div>-->
<!--        &lt;!&ndash;startprint&ndash;&gt;
        <div id="printMe">?221321
            <div v-html='text'></div>
        </div>
        &lt;!&ndash;endprint&ndash;&gt;
   &lt;!&ndash;    -->

    </div>
</template>

<script>
    // import 'form-making/dist/FormMaking.less'
    import gql from 'graphql-tag';
    export default {
        name: '',
        data() {
            return {
                jsonData: {
                    "list": [
                        {
                            "type": "time",
                            "icon": "icon-time",
                            "options": {
                                "defaultValue": "",
                                "readonly": false,
                                "disabled": false,
                                "editable": true,
                                "clearable": true,
                                "placeholder": "",
                                "startPlaceholder": "",
                                "endPlaceholder": "",
                                "isRange": false,
                                "arrowControl": true,
                                "format": "HH:mm:ss",
                                "required": false,
                                "width": "",
                                "remoteFunc": "func_1581265391000_46974"
                            },
                            "name": "时间选择器",
                            "key": "1581265391000_46974",
                            "model": "time_1581265391000_46974",
                            "rules": []
                        },
                        {
                            "type": "rate",
                            "icon": "icon-pingfen1",
                            "options": {
                                "defaultValue": 0,
                                "max": 5,
                                "disabled": false,
                                "allowHalf": false,
                                "required": false,
                                "remoteFunc": "func_1581265392000_30867"
                            },
                            "name": "评分",
                            "key": "1581265392000_30867",
                            "model": "rate_1581265392000_30867",
                            "rules": []
                        },
                        {
                            "type": "slider",
                            "icon": "icon-slider",
                            "options": {
                                "defaultValue": 0,
                                "disabled": false,
                                "required": false,
                                "min": 0,
                                "max": 100,
                                "step": 1,
                                "showInput": false,
                                "range": false,
                                "width": "",
                                "remoteFunc": "func_1581265394000_23813"
                            },
                            "name": "滑块",
                            "key": "1581265394000_23813",
                            "model": "slider_1581265394000_23813",
                            "rules": []
                        }
                    ],
                    "config": {
                        "labelWidth": 100,
                        "labelPosition": "right",
                        "size": "small"
                    }
                }, // 表单配置中生成的json数据
                values: {}, // 表单需要显示的表单数据
                remoteFuncs: {
                    // 组件配置时配置的远端方法,保持和配置时输入的名称一致
                    func_test (resolve) {
                        // 模拟接口请求
                        setTimeout(() => {
                            const options = [
                                {id: '1', name: '1111'},
                                {id: '2', name: '2222'},
                                {id: '3', name: '3333'}
                            ]

                            // 获取到的值和标签可以通过配置页远端配置
                            // 值:id  标签：name
                            resolve(options) // 将后端获取的数据放入回调函数中
                        }, 2000)
                    },

                },
                templateRules:{
                    templ_name: [
                        { required: true, message: '请输入模板名称', trigger: 'blur' },
                    ],
                },
                templateValue:"",
                dialogVisible:false,
                info:"信息",
                text:"<div>测试文字{{info}}</div>",
                printObjT:{
                    id: "printMe",
                    popTitle: 'good print',
                    extraCss: 'https://www.baidu.com',
                    extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>'
                },
                templateForm:{
                    remarks:"",
                    templ_name:"",
                },
                upOrAdd:0,
                template:{},
            }
        },
        methods: {
            showTempleteValue(){
                this.dialogVisible = true;
            },
            addTemplete(){
                /* tslint:disable:no-string-literal */
                this.$refs['templateForm'].validate(async(valid)  => {
                    /* tslint:enable:no-string-literal */
                    if (valid) {
                        try {
                            const json = this.$refs.makingform.getJSON()
                            this.templateForm.templ_content = JSON.stringify(json)
                            let res = await this.$apollo.mutate({
                                mutation: gql`mutation ($templ_name: String!,$templ_content: String!,$remarks: String!) {
                    addTemplate(
                    templ_name: $templ_name
                    templ_content: $templ_content
                    remarks: $remarks
                    ){
                      id
                    }
                }`,
                                variables: this.templateForm
                            });
                            this.$message({
                                message: "新增成功!",
                                type: "success"
                            });
                            this.dialogVisible = false;
                        }catch (e) {
                            this.$message.error(error.message.split(":")[1]);
                        }
                    } else {
                        return false;
                    }
                });
            },
            upTemplete(){
                let keys = 'templateForm';
                this.$refs[keys].validate(async(valid)  => {
                    if (valid) {
                        try {
                            const json = this.$refs.makingform.getJSON()
                            this.templateForm.id = this.template.id;
                            this.templateForm.templ_content = JSON.stringify(json)
                            let res = await this.$apollo.mutate({
                                mutation: gql`mutation ($id: Int!,$templ_name: String!,$templ_content: String!,$remarks: String!) {
                    modifyTemplate(
                    id: $id
                    templ_name: $templ_name
                    templ_content: $templ_content
                    remarks: $remarks
                    ){
                      id
                    }
                }`,
                                variables: this.templateForm
                            });
                            this.$message({
                                message: "新增成功!",
                                type: "success"
                            });
                            this.dialogVisible = false;
                        }catch (e) {
                            this.$message.error(error.message.split(":")[1]);
                        }
                    } else {
                        return false;
                    }
                });
            },
           async saveTempleteValue(){
               if (this.upOrAdd === 0){
                   this.addTemplete();
               }else if (this.upOrAdd === 1){
                   this.upTemplete();
               }
            },
            init(){
                if (this.$route.params.template!==undefined){
                    this.template = this.$route.params.template;
                    this.templateForm.remarks = this.template.remarks;
                    this.templateForm.templ_name = this.template.templ_name;
                    this.$refs.makingform.setJSON(JSON.parse(this.$route.params.template.templ_content))
                    this.upOrAdd = 1;
                }else {
                    this.upOrAdd = 0;
                }
            },
        },
        mounted() {
            this.init();
        },
    }
</script>

<!--<style lang="less"  scoped>
    @import '../assets/style/FormMaking.less';
</style>-->
<style lang="less"  scoped>
    .el-tabs__content{
        height: 100%;
    }
    .wrapper {
        width: 100%;
        height: calc(100% - 40px);

        .item {
            margin-top: 20px;
        }

        .item-head {
            display: flex;
            height: 36px;
            justify-content: space-between;
            align-items: center;
            border-bottom: 1px solid #55a9c6;

            .til {
                color: #47a2bf;
                padding-left: 5px;
                font-size: 14px;
                font-weight: bold;
            }

            .save-btn {
                width: 80px;
                height: 20px;
                color: #fff;
                border-radius: 5px;
                background-color: #47a2bf;
                text-align: center;
                line-height: 20px;
                font-size: 12px;
                cursor: pointer;
            }
        }

        .parameter-list {
            .list-item {
                padding-left: 5px;
                margin-top: 10px;

                .list-til {
                    display: inline-block;
                    width: 100px;
                    font-size: 14px;
                    font-weight: bold;
                }

                input {
                    width: 270px;
                    height: 30px;
                    border: 1px solid #bbb;
                    border-radius: 5px;
                    text-indent: 10px;
                    outline: none;
                }
            }
        }
    }
</style>
